import React, { useEffect, useRef } from "react";
import { Box, Dialog, DialogContent, IconButton, useTheme } from "@mui/material";
import { DeleteRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const Preview = (props: any) => {
    const { onClose, attach, open, deleteAction } = props;

    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);

    const previewRef = useRef(null);

    const handleClose = () => {
        onClose();
    };

    const handleDeleteDamage = (e: React.SyntheticEvent, attach: any) => {
        e.stopPropagation();

        deleteAction(attach);
        onClose();
    }

    useEffect(() => {
        if (open && !!attach?.file) {
            setTimeout(() => {
                // @ts-ignore
                previewRef.current.src = attach.file;
            }, 100);
        }
    }, [props]);

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogContent>
                <img ref={previewRef} style={{width: "100%"}}
                    id="preview"
                    src="#"
                    alt="Preview"
                />

                {
                    !!deleteAction &&
                    <Box sx={{width: "100%", display: "flex", justifyContent: "center", mt: theme.spacing(1)}}>
                        <IconButton color="accent" size={"large"}
                                    onClick={(e: React.SyntheticEvent) => handleDeleteDamage(e, attach)}>
                            <DeleteRounded />
                        </IconButton>
                    </Box>
                }
            </DialogContent>
        </Dialog>
    );
}

export default Preview;